import { observer } from 'mobx-react-lite';
import React from 'react';
import { createPortal } from 'react-dom';
import { portals } from './Portals';

export const PortalOutlet = observer(() => {
  // Get the list of portals that need to be rendered
  // into the react dom tree.
  //
  // Each portal is a (ReactNode, HtmlElement) pair
  // where the ReactNode is the react ui and the HtmlElement
  // is the existing DOM target to render into.
  //
  // The AngularJS app is responsible for adding the HtmlElement
  // to the DOM and passing it to the `portals.render(...)` method.
  //
  // Note that we render each of the ReactNode `portal.node` elements
  // inside a ShadowRoot component.
  // The ShadowRoot ensures that any styled-components can be styled
  // without legacy global css rules interfering.
  const items = portals.items();
  return (
    <>
      {items.map(([key, portal]) => {
        return createPortal(
          // I attempted to render each react node within an isolated shadowDom root
          // but it broke the tab-index for braintree's hosted fields payment form.
          //
          // <ShadowRoot key={key} host={portal.element}>
          //   {portal.node}
          // </ShadowRoot>,
          portal.node,
          portal.element,
          key
        );
      })}
    </>
  );
});
